import type { AudienceAge } from "app/pages/sales-intelligence/domain/leads/types/enums";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculateArrayDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";

export default class FindAudienceAgeFilter extends FilterPanelBaseFilter<
    readonly AudienceAge[],
    readonly AudienceAge[]
> {
    constructor(deps: IFilterPanelBaseFilterDeps<readonly AudienceAge[], readonly AudienceAge[]>) {
        super(deps);
    }

    calculateValueDelta = (
        previousValue: readonly AudienceAge[] | undefined,
        newValue: readonly AudienceAge[] | undefined,
    ): FilterValueDelta<AudienceAge> => {
        return calculateArrayDelta(previousValue, newValue);
    };
}
